export const formatUptime = (uptimeSeconds) => {
  if (uptimeSeconds === null || uptimeSeconds === undefined) {
    return 'N/A';
  }
  
  const totalSeconds = Math.floor(uptimeSeconds);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  
  if (days > 0) {
    return `${days}d ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Format an ISO 8601 datetime string (UTC/GMT from server) to local timezone.
 * The server sends timestamps in UTC/GMT, and this function converts them to
 * the user's local timezone for display.
 * 
 * @param {string} isoString - ISO 8601 datetime string in UTC/GMT (e.g., "2024-01-01T12:00:00Z")
 * @returns {string} - Formatted datetime string in user's local timezone
 */
export const formatDateTime = (isoString) => {
  if (!isoString) return 'N/A';
  // Parse ISO string (JavaScript automatically handles UTC timezone markers like 'Z' or '+00:00')
  const date = new Date(isoString);
  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }
  // Convert UTC timestamp to local timezone and format
  return date.toLocaleString();
};

/**
 * Format an ISO 8601 datetime string (UTC/GMT from server) as relative time.
 * The server sends timestamps in UTC/GMT, and this function calculates the
 * relative time difference correctly regardless of timezone.
 * 
 * @param {string} isoString - ISO 8601 datetime string in UTC/GMT (e.g., "2024-01-01T12:00:00Z")
 * @returns {string} - Relative time string (e.g., "5 minutes ago")
 */
export const formatRelativeTime = (isoString) => {
  if (!isoString) return 'N/A';
  // Parse ISO string (JavaScript automatically handles UTC timezone markers)
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  
  if (seconds < 60) return `${seconds} seconds ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} minutes ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} hours ago`;
  return `${Math.floor(seconds / 86400)} days ago`;
};

